import type { ReactNode } from 'react';

/**
 * Layout wrapper used for admin/backoffice apps with header + sidebar slots.
 */
export interface AdminShellProps {
  sidebar?: ReactNode;
  header?: ReactNode;
  children?: ReactNode;
  className?: string;
}

/**
 * Provides a two-column layout with a fixed sidebar area and a content region.
 */
export function AdminShell({ sidebar, header, children, className }: AdminShellProps): JSX.Element {
  const containerClasses = ['admin-shell', className].filter(Boolean).join(' ');

  const resolvedHeader = header ?? (
    <div className="admin-shell__header-bar">
      <span className="admin-shell__title">Pericles Studio</span>
    </div>
  );

  const resolvedSidebar = sidebar ?? (
    <div className="admin-shell__sidebar-inner">
      <p className="admin-shell__sidebar-title">Navigation</p>
      <p className="admin-shell__sidebar-subtitle">Add your links here.</p>
    </div>
  );

  return (
    <div className={containerClasses}>
      <header className="admin-shell__header">{resolvedHeader}</header>
      <div className="admin-shell__body">
        <aside className="admin-shell__sidebar">{resolvedSidebar}</aside>
        <main className="admin-shell__main">
          <div className="admin-shell__content">{children}</div>
        </main>
      </div>
    </div>
  );
}
